import type { FunctionComponent, HTMLAttributes, ReactElement } from 'react';
import { Children } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';
import { Icon } from '../../icons/icon';
import { Icons } from '../../icons/iconNames';

import styles from './modalSection.module.css';

export interface ModalSectionProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  action?: ReactElement;
  disabled?: boolean;
  icon?: keyof Icons;
  title?: ReactElement | string;
  dataTestId?: string;
  modalSectionClass?: string;
  modalSectionHeaderClass?: string;
  modalSectionGridClass?: string;
}

export const ModalSection: FunctionComponent<ModalSectionProps> = ({
  action,
  children,
  disabled,
  icon,
  title,
  dataTestId,
  modalSectionClass = '',
  modalSectionHeaderClass = '',
  modalSectionGridClass = '',
}): ReactElement => {
  const mods = useModifiers(styles, 'modalSection', { disabled }, { withBaseClass: true });

  return (
    <section data-testid={dataTestId ? `${dataTestId}` : 'modal-section'} className={`${mods} ${modalSectionClass}`}>
      <header className={`${styles.modalSection__header} ${modalSectionHeaderClass}`}>
        <div className={styles.modalSection__headerContent}>
          {icon ? <Icon icon={icon} /> : null}
          <div className={styles.modalSection__title}>{title}</div>
        </div>
        {action ? <div className={styles.modalSection__headerAction}>{action}</div> : null}
      </header>
      {Children.count(children) ? (
        <div className={`${styles.modalSection__grid} ${modalSectionGridClass}`}>{children}</div>
      ) : null}
    </section>
  );
};
